import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchPermission, updatePermission } from "actions/permission";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Permission/Form";

class PermissionEdit extends Component {
  componentDidMount() {
    const { match, fetchPermission } = this.props;
    const id = match.params.permissionId;
    fetchPermission(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.permission.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updatePermission(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updatePermission, history } = this.props;

    toggleFullPageSpinner(true);

    updatePermission(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated Permission Success", infoClassName: "is-success" });
        history.push(`/permissions`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.permissionId;

    this.updatePermission(id, data);
  };

  render() {
    const { permission } = this.props;

    if (permission.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ permission }) => ({
  permission
});

export default connect(
  mapStateToProps,
  {
    fetchPermission,
    updatePermission,
    toggleFullPageSpinner,
    toggleNotification
  }
)(PermissionEdit);



// WEBPACK FOOTER //
// ./src/pages/Permission/Edit/index.js